import React from "react";
import {PropertyDefinitionDto} from "./apis/property/PropertyApi";

export interface ElementPropertyDefinition {
    propertyDefinitions: PropertyDefinitionDto[];
    updatePropertyDefinitions: () => void;
}

const ElementPropertyDefinitionContext = React.createContext<ElementPropertyDefinition>({
    propertyDefinitions: [],
    updatePropertyDefinitions: () => {}
});

export default ElementPropertyDefinitionContext;